const isValidIP = (input: string): boolean => {
  const ipPattern = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
  const match = input.match(ipPattern);
  return match
    ? match.slice(1, 5).every((num) => Number(num) >= 0 && Number(num) <= 255)
    : false;
};

const isValidCIDR = (input: string): boolean => {
  const parts = input.split('/');
  if (parts.length !== 2) {
    return false;
  }

  const [ip, prefix] = parts;
  if (ip === undefined || prefix === undefined || prefix === '') {
    return false;
  }

  const prefixNum = Number(prefix);
  return (
    isValidIP(ip) &&
    !Number.isNaN(prefixNum) &&
    prefixNum >= 0 &&
    prefixNum <= 32
  );
};

export const isIPv4 = (ip: string): boolean => {
  return isValidIP(ip) || isValidCIDR(ip);
};

export const convertIpTo32BitInt = (ip: string): number => {
  return (
    ip
      .split('.')
      .map((num) => Number.parseInt(num, 10))
      .reduce((acc, num) => (acc << 8) | num, 0) >>> 0
  );
};

const isSubnetWithinParent = (subnet: string, parent: string): boolean => {
  const [subnetIP, subnetPrefix] = subnet.split('/');
  const [parentIP, parentPrefix] = parent.split('/');

  if (subnetIP === undefined || parentIP === undefined) {
    return false;
  }

  const subnetBin = convertIpTo32BitInt(subnetIP);
  const parentBin = convertIpTo32BitInt(parentIP);
  const parentMask = 32 - Number(parentPrefix);

  return (
    Number(subnetPrefix) >= Number(parentPrefix) &&
    subnetBin >>> parentMask === parentBin >>> parentMask
  );
};

const isCIDRParent = (queryCIDR: string, itemCIDR: string): boolean => {
  return isValidCIDR(itemCIDR) && isSubnetWithinParent(queryCIDR, itemCIDR);
};

export const filterIPv4IPs = (query: string, ipList: string[]): string[] => {
  if (isValidCIDR(query)) {
    if (query.endsWith('/32')) {
      // If query is IP/32, search only for exact match
      const ipOnly = query.split('/')[0];
      return ipList.filter((item) => item === query || item === ipOnly);
    }

    return ipList.filter((item) => item === query || isCIDRParent(query, item));
  }

  if (isValidIP(query)) {
    return ipList.filter(
      (item) =>
        item === query ||
        (isValidCIDR(item) && isSubnetWithinParent(`${query}/32`, item)),
    );
  }

  return ipList.filter((item) => item.includes(query));
};
